import { useQuery } from "@tanstack/react-query";
import { WhyCard } from "~/api/models/WhyHS";
import { QueryKeys } from "~/queryKeys";
import {
  StoryblokMultiStoryResult,
  storyblokRoutes,
  storyblokServiceSingleton,
} from "~/services/storyblok";
import { useLocaleStore } from "~/stores/locale/useLocaleStore";

export const useFetchIntroMainCard = () => {
  const { locale } = useLocaleStore();
  return useQuery<
    StoryblokMultiStoryResult<WhyCard>,
    WhyCard | undefined,
    WhyCard | undefined
  >({
    queryKey: [QueryKeys.useFetchIntroMainCard, locale],
    queryFn: () =>
      storyblokServiceSingleton.get(storyblokRoutes.whyMainCard, {
        locale,
      }),
    select: (data) =>
      data.data.stories.length ? data.data.stories[0].content : undefined,
  });
};
